module.exports = __webpack_public_path__ + "static/img/img_5.0bf6aa73.jpg";